
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ethereum-development-services",
      function () {
        return require("private-next-pages/ethereum-development-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ethereum-development-services"])
      });
    }
  